var render = function render(){
  var _vm$postponeModal$dat, _vm$firstRow5;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('i', {
          staticClass: "fa fa-arrow-left mr-3 text-primary",
          staticStyle: {
            "cursor": "pointer",
            "font-size": "20px"
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push('/maintenance/maintenance-transactional');
            }
          }
        }), _c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("PMS (Plan Maintenance System) History")])])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$firstRow, _vm$firstRow$equipmen, _vm$firstRow2, _vm$firstRow3, _vm$firstRow4;
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center mb-3"
        }, [_c('div', {
          staticClass: "mb-3"
        }, [_vm.firstRow ? _c('h4', {
          staticClass: "align-middle mb-0 d-flex align-items-center"
        }, [_c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(_vm._s((_vm$firstRow = _vm.firstRow) === null || _vm$firstRow === void 0 ? void 0 : _vm$firstRow.vehicle_name))]), _c('strong', {
          staticClass: "text-primary ml-3"
        }, [_vm._v(" " + _vm._s((_vm$firstRow$equipmen = (_vm$firstRow2 = _vm.firstRow) === null || _vm$firstRow2 === void 0 ? void 0 : _vm$firstRow2.equipment_name) !== null && _vm$firstRow$equipmen !== void 0 ? _vm$firstRow$equipmen : '_') + " ")])], 1) : _vm._e()]), _c('b-button', {
          staticClass: "ml-auto",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.handleExport
          }
        }, [_c('i', {
          staticClass: "fa fa-file-export mr-1"
        }), _vm._v(" Export ")])], 1), _c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table align-middle table-striped table-hover table-bordered"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', [_vm._v("Job Name")]), _c('th', [_vm._v("Job Type / Class")]), _c('th', [_vm._v("Interval")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Last")]), _c('th', [_vm._v("Due")]), _c('th', [_vm._v("Postpone")]), _c('th', [_vm._v("Actual")]), ((_vm$firstRow3 = _vm.firstRow) === null || _vm$firstRow3 === void 0 ? void 0 : _vm$firstRow3.triggers) == 'COUNTER' ? _c('th', [_vm._v("Interval Process")]) : _vm._e(), _c('th', [_vm._v("Status")]), _c('th')])]), _c('tbody', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm.isLoading ? _c('tr', [_c('td', {
          staticClass: "text-center py-4",
          attrs: {
            "colspan": ((_vm$firstRow4 = _vm.firstRow) === null || _vm$firstRow4 === void 0 ? void 0 : _vm$firstRow4.triggers) == 'COUNTER' ? 10 : 9
          }
        }, [_c('b-spinner', {
          attrs: {
            "label": "Loading..."
          }
        })], 1)]) : _vm._l(_vm.maintenanceData, function (job, index) {
          var _job$pms_vehicle, _job$pms_vehicle2, _job$pms_vehicle3, _job$maintenance_has_, _job$maintenance_has_2, _job$maintenance_has_3, _job$maintenance_has_4;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "align-middle"
          }, [_c('div', {
            staticClass: "text-capitalize"
          }, [_c('strong', [_vm._v(_vm._s(job === null || job === void 0 ? void 0 : job.job_name))])])]), _c('td', {
            staticClass: "p-0"
          }, [_c('div', {
            staticClass: "font-weight-bold p-2 text-nowrap px-3"
          }, [_vm._v(" " + _vm._s(job === null || job === void 0 ? void 0 : job.job_type_name) + " ")]), _c('div', {
            staticClass: "border-top p-2 px-3"
          }, [_c('small', {
            staticClass: "text-muted"
          }, [_vm._v(" " + _vm._s(job === null || job === void 0 ? void 0 : job.job_class_name) + " ")])])]), _c('td', {
            staticClass: "p-0"
          }, [_c('div', {
            staticClass: "p-2 px-3"
          }, [job.triggers == 'CALENDAR' ? _c('div', [_vm._v(" " + _vm._s((_job$pms_vehicle = job.pms_vehicle) === null || _job$pms_vehicle === void 0 ? void 0 : _job$pms_vehicle.calendar_interval) + " " + _vm._s((_job$pms_vehicle2 = job.pms_vehicle) === null || _job$pms_vehicle2 === void 0 ? void 0 : _job$pms_vehicle2.calendar_type) + " ")]) : _c('div', {
            staticClass: "font-semibold"
          }, [_vm._v(" " + _vm._s(_vm.formatNumber((_job$pms_vehicle3 = job.pms_vehicle) === null || _job$pms_vehicle3 === void 0 ? void 0 : _job$pms_vehicle3.interval_hour)) + " Hours ")])]), _c('div', {
            staticClass: "p-2 px-3 border-top"
          }, [_c('small', {
            staticClass: "text-muted"
          }, [_vm._v(" " + _vm._s(job.triggers || '-') + " ")])])]), _c('td', {
            staticClass: "p-0 text-center"
          }, [_c('div', {
            staticClass: "p-2 px-3"
          }, [_vm._v(" " + _vm._s(job.last_maintenance_date ? _vm.moment(job.last_maintenance_date).format('DD/MM/YYYY') : '-') + " ")]), job.triggers == 'COUNTER' ? _c('div', {
            staticClass: "border-top p-2 px-3 font-semibold"
          }, [_vm._v(" " + _vm._s(job.last_maintenance_hours ? _vm.formatNumber(job.last_maintenance_hours) + ' Hours' : '-') + " ")]) : _vm._e()]), _c('td', [job.triggers == 'CALENDAR' ? _c('div', [_vm._v(" " + _vm._s(_vm.moment(job.possible_maintenance_date).format('DD/MM/YYYY')) + " ")]) : _vm._e(), job.triggers == 'COUNTER' ? _c('div', {
            staticClass: "font-semibold"
          }, [_vm._v(" " + _vm._s(_vm.formatNumber(job.possible_maintenance_hours)) + " Hours ")]) : _vm._e()]), _c('td', [job !== null && job !== void 0 && (_job$maintenance_has_ = job.maintenance_has_postpone) !== null && _job$maintenance_has_ !== void 0 && _job$maintenance_has_.length ? _c('div', {
            staticClass: "text-primary cursor-pointer",
            staticStyle: {
              "text-decoration-line": "underline"
            },
            on: {
              "click": function click($event) {
                return _vm.showPostponeModal(job);
              }
            }
          }, [job.triggers == 'CALENDAR' ? [_vm._v(" " + _vm._s((_job$maintenance_has_2 = job.maintenance_has_postpone[0]) !== null && _job$maintenance_has_2 !== void 0 && _job$maintenance_has_2.extra_date ? _vm.moment((_job$maintenance_has_3 = job.maintenance_has_postpone[0]) === null || _job$maintenance_has_3 === void 0 ? void 0 : _job$maintenance_has_3.extra_date).format('DD/MM/YYYY') : '-') + " ")] : [_vm._v(" " + _vm._s(_vm.formatNumber((_job$maintenance_has_4 = job.maintenance_has_postpone[0]) === null || _job$maintenance_has_4 === void 0 ? void 0 : _job$maintenance_has_4.extra_hours)) + " Hours ")]], 2) : _c('div', [_vm._v("-")])]), _c('td', {
            staticClass: "p-0"
          }, [_c('div', {
            staticClass: "p-2 px-3"
          }, [_vm._v(" " + _vm._s(job.maintenance_date ? _vm.moment(job.maintenance_date).format('DD/MM/YYYY') : '-') + " ")]), job.triggers == 'COUNTER' ? _c('div', {
            staticClass: "border-top p-2 px-3 font-semibold"
          }, [_vm._v(" " + _vm._s(_vm.formatNumber(job.maintenance_running_hours)) + " Hours ")]) : _vm._e()]), job.triggers == 'COUNTER' ? _c('td', {
            staticClass: "font-semibold"
          }, [[_vm._v(" " + _vm._s(_vm.formatNumber(job === null || job === void 0 ? void 0 : job.interval_process) || '0') + " Hours ")]], 2) : _vm._e(), _c('td', [_c('span', {
            staticClass: "badge",
            class: _vm.getStatusBadgeClass(job.status)
          }, [_vm._v(" " + _vm._s(job.status == 'MAINTENANCE' ? 'PROGRESS' : job.status || '-') + " ")])]), _c('td', {
            staticClass: "text-center"
          }, [_c('b-button', {
            staticClass: "p-1",
            attrs: {
              "id": "action-popover-".concat(index),
              "size": "sm",
              "variant": "link"
            }
          }, [_c('i', {
            staticClass: "fas fa-ellipsis-v text-dark"
          })]), _c('b-popover', {
            attrs: {
              "target": "action-popover-".concat(index),
              "placement": "bottom",
              "triggers": "focus"
            }
          }, [_c('div', {
            staticClass: "list-group list-group-flush"
          }, _vm._l(_vm.getActionMenuByJob(job, index), function (item, i) {
            return _c('button', {
              key: "act-".concat(i, "-").concat(item.key),
              staticClass: "list-group-item list-group-item-action",
              class: {
                'text-danger': item.variant === 'danger'
              },
              attrs: {
                "type": "button"
              },
              on: {
                "click": function click($event) {
                  return _vm.handleAction(item.key, job, index);
                }
              }
            }, [_vm._v(" " + _vm._s(item.label) + " ")]);
          }), 0)])], 1)]);
        })], 2)]), _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-between"
        }, [_c('div', [_c('span', {
          staticClass: "mb-0"
        }, [_vm._v(" Total Rows : "), _c('strong', [_vm._v(_vm._s(_vm.filters.total))])])]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.filters.total,
            "per-page": _vm.filters.limit,
            "disabled": _vm.isLoading,
            "first-number": "",
            "align": "center"
          },
          on: {
            "input": function input() {
              return _vm.fetchData();
            }
          },
          model: {
            value: _vm.filters.page,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "page", $$v);
            },
            expression: "filters.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions,
            "disabled": _vm.isLoading
          },
          on: {
            "input": function input() {
              return _vm.fetchData();
            }
          },
          model: {
            value: _vm.filters.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "limit", $$v);
            },
            expression: "filters.limit"
          }
        })], 1)])])];
      },
      proxy: true
    }])
  }), _c('CustomSidebar', {
    attrs: {
      "title": _vm.sidebar.title,
      "size": _vm.sidebar.size
    },
    model: {
      value: _vm.sidebar.show,
      callback: function callback($$v) {
        _vm.$set(_vm.sidebar, "show", $$v);
      },
      expression: "sidebar.show"
    }
  }, [_vm.sidebar.title == 'Edit Maintenance' ? [_vm.sidebar.show ? _c('MaintenanceProcessInfo', {
    attrs: {
      "selectedData": _vm.sidebar.data,
      "isEditMode": true
    },
    on: {
      "refetch": _vm.fetchData,
      "close": function close($event) {
        _vm.sidebar.show = false;
      }
    }
  }) : _vm._e()] : _vm._e(), _vm.sidebar.title == 'Detail Maintenance' ? [_c('MaintenanceDetail', {
    attrs: {
      "selectedData": _vm.sidebar.data,
      "isHistoryDetail": true
    }
  })] : _vm._e()], 2), _c('b-modal', {
    attrs: {
      "title": "Postpone Info",
      "centered": "",
      "hide-footer": ""
    },
    model: {
      value: _vm.postponeModal.show,
      callback: function callback($$v) {
        _vm.$set(_vm.postponeModal, "show", $$v);
      },
      expression: "postponeModal.show"
    }
  }, [(_vm$postponeModal$dat = _vm.postponeModal.data) !== null && _vm$postponeModal$dat !== void 0 && _vm$postponeModal$dat.length ? [_c('PostponeLogs', {
    attrs: {
      "logs": _vm.postponeModal.data,
      "method": ((_vm$firstRow5 = _vm.firstRow) === null || _vm$firstRow5 === void 0 ? void 0 : _vm$firstRow5.triggers) || 'CALENDAR'
    }
  })] : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }